//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import { RESELLER, HASHTAG } from '@/scripts/constants/parameters'
import { ZERO_PLACEHOLDER } from '@/scripts/constants/placeholders'
import { MOBILE, TABLET } from '@/scripts/constants/media-query'
import { WcsCertifiedReseller } from '@/scripts/libs/wcs/certified-reseller'

const url = (value) => {
  const validator =
    !!value &&
    value
      ?.toLowerCase()
      ?.match(
        /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)/g
      )
  return !!validator
}

export default {
  name: 'rb-certified-reseller',
  validations: {
    urlAddress: {
      required,
      url,
    },
  },
  data() {
    return {
      isResultVisible: false,
      isDomainCertifiedReseller: undefined,
      domainType: '',
      urlAddress: '',
      initialValue: '',
    }
  },
  computed: {
    ...mapGetters(['translation']),
    getCertifiedResellerMessage() {
      return this.translation('certified_resellers.domain_is').replace(
        ZERO_PLACEHOLDER,
        this.translation(`certified_resellers.${this.domainType.toLowerCase()}`)
      )
    },
    getPlaceholder() {
      return 'www.ray-ban.com'
    },
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search)
    const reseller = urlParams.get(RESELLER)
    if (reseller) {
      this.initialValue = reseller
      this.urlAddress = reseller
      this.onSearchClick()
      location.href = HASHTAG + this.$refs.resellerContainer.id
    }
  },
  methods: {
    async onSearchClick() {
      this.$v.$touch()

      if (!!this.urlAddress && !this.$v.$invalid) {
        const response = await WcsCertifiedReseller.fetchIsCertifiedReseller(this.urlAddress)

        if (response) {
          this.showResult()
          // TODO: Result is a String not a Boolean as per requirements
          this.isDomainCertifiedReseller = response.result === 'true'
          this.domainType = response.type
        }
      }
    },
    showResult() {
      this.isResultVisible = true
    },
  },
}
